<template>
  <div class="policy-measure-browser">
    <p class="policy-city-measure-note">共 {{ measures.length }} 项符合条件的措施。选择措施名称查看详情并调整执行强度。</p>
    <div v-if="activeMeasure" class="policy-city-measures-layout policy-measure-browser-layout">
      <nav class="policy-city-measure-list" aria-label="部门措施列表">
        <button v-for="measure in measures" :key="measureId(measure)" type="button"
          :class="{ active: measureId(measure) === measureId(activeMeasure) }"
          :aria-pressed="measureId(measure) === measureId(activeMeasure)"
          :data-linked-measure="measureId(measure)" @click="selectMeasure(measure)">
          <span>{{ measure.name }}</span><small>{{ isEnabled(measure) ? '已启用 · ' + intensity(measure) + '级' : '未启用' }}</small>
        </button>
      </nav>
      <article :key="measureId(activeMeasure)" class="policy-city-measure-detail policy-measure-card" aria-label="措施详情" :data-measure-id="measureId(activeMeasure)">
        <div class="policy-measure-card-heading"><div><h4>{{ activeMeasure.name }}</h4><small>{{ measureId(activeMeasure) }} · {{ activeMeasure.category || activeMeasure.type || '未分类' }} · {{ activeMeasure.allowRepeat === false ? '仅可执行一次' : '可跨轮次执行' }}</small></div><span class="lab-tag" :class="isEnabled(activeMeasure) ? 'green' : 'gray'">{{ isEnabled(activeMeasure) ? '已启用' : '未启用' }}</span></div>
        <slot name="actions" :measure="activeMeasure" />
        <dl class="policy-city-measure-fields"><dt>所属部门</dt><dd>{{ departmentName || '—' }}</dd><dt>措施描述</dt><dd>{{ activeMeasure.desc || activeMeasure.description || '暂无措施说明' }}</dd></dl>
        <dl class="policy-city-measure-resources">
          <div><dt>{{ legacy ? '授权资源' : '权威资源' }}（每强度）</dt><dd>{{ legacy ? (activeMeasure.authCostFormula || '强度 × 5') : value(activeMeasure.auth) }}</dd></div>
          <div><dt>财政花费（每强度）</dt><dd>{{ legacy ? (activeMeasure.budgetCostFormula || '强度 × 100') : value(activeMeasure.cost, ' 万元') }}</dd></div>
          <div><dt>实施周期（每强度）</dt><dd>{{ legacy ? (activeMeasure.periodFormula || '强度 × 3 天') : value(activeMeasure.period, ' 天') }}</dd></div>
        </dl>
        <dl class="policy-city-measure-fields">
          <dt>贡献值公式</dt><dd><code class="policy-city-measure-formula">{{ activeMeasure.formula || (legacy ? '按案例配置的执行规则计算' : '暂未配置') }}</code></dd>
          <template v-if="!legacy || activeMeasure.weights"><dt>核心指标贡献权重</dt><dd><dl class="policy-city-measure-weights"><div v-for="weight in weights" :key="weight.key"><dt>{{ weight.label }}</dt><dd>{{ value((activeMeasure.weights || {})[weight.key]) }}</dd></div></dl></dd></template>
        </dl>
        <p class="policy-city-measure-note">资源消耗与实施周期按执行强度计算，强度为 0 时停用。</p>
      </article>
    </div>
    <p v-else class="lab-empty">当前部门没有符合条件的措施。</p>
  </div>
</template>

<script>
export default {
  name: 'PolicyMeasureBrowser',
  props: {
    measures: { type: Array, default: () => [] },
    departmentName: String,
    indicators: { type: Array, default: () => [] },
    intensity: { type: Function, required: true },
    idFor: Function,
    legacy: Boolean
  },
  data () { return { selectedId: '' } },
  computed: {
    activeMeasure () { return this.measures.find(item => this.measureId(item) === this.selectedId) || this.measures[0] || null },
    weights () { return ['willing', 'registered', 'result', 'satis'].map((key, index) => ({ key, label: (this.indicators.find(item => item.semantic === key) || {}).name || ['意愿', '登记', '成效', '满意度'][index] })) }
  },
  methods: {
    measureId (measure) { return String(this.idFor ? this.idFor(measure) : measure.id) },
    isEnabled (measure) { return Number(this.intensity(measure)) > 0 },
    value (value, unit = '') { return value == null || value === '' ? '暂未配置' : String(value) + unit },
    selectMeasure (measure) { this.selectedId = this.measureId(measure); this.$emit('select', measure) }
  }
}
</script>
